export default function ImageBox(props){
  const images = props.images?? null;
  return (
    <div className="flex flex-col lg:w-[428px]">
      {images.map((image, index)=>{
        return (
          <picture key={index}>
            <img src={image} className="border border-gray-200"
            alt='product'
            sizes="(max-width: 700px) 320px, 428px"/>
          </picture>
        );
      })}
    </div>
  );
}